<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="title"
      width="400px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
    >
      <div style="width: 100%;">
        <el-form v-if="type=== 0" label-width="80px" label-position="right">
          <el-form-item :label="this.$t('CargoMsg.Cargo_RouteMarking')">
            <el-input v-model="from.routeMarking" no="routeMarking" style="width: 200px" />
          </el-form-item>
        </el-form>
        <el-form v-if="type=== 1" label-width="80px" label-position="right">
          <el-form-item :label="$t('CargoMsg.Cargo_FlightNumber')">
            <el-input v-model="from.voyageFlight" no="voyageFlight" style="width: 250px" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_FlightDate')">
            <el-date-picker
              ref="etd"
              v-model="from.etd"
              no="etd"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              clearable
              style="flex: 1; width:250px;"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_FreightUnitPrice')">
            <div style="display: flex;width: 250px">
              <auto-number-input
                v-model="from.freightAmount"
                no="freightAmount"
                :precision="0"
                style="width: 110px"
                :min="0"
              />
              <el-select v-model="from.freightType" no="freightType" style="width: 100px">
                <el-option :label="$t('CargoMsg.Cargo_UnitPrice')" :value="0" />
                <el-option :label="$t('CargoMsg.Cargo_TotalPrice')" :value="1" />
              </el-select>
              <cargo-advance-select
                filterable
                style="width: 100px"
                :clearable="false"
                :select-type="selectTypeNames.basic_data_Currency"
                :default-value="from.freightCurrency"
                @parentCallBack="item=>from.freightCurrency=item.value"
              />
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right">
          <el-button type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          <el-button @click="closeHandler">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { updateRouteBookingFunc } from '@/api/AirExport/airExportJob'

export default {
  name: 'ChangeDataWindow',
  components: { AutoNumberInput, CargoAdvanceSelect, cargoUserSelect },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: false, default: '' },
    type: { type: Number, required: false, default: 0 },
    uuids: { type: Array, required: true }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      selectTypeNames: TYPE_NAMES,
      from: {
        routeMarking: '',
        etd: null,
        voyageFlight: '',
        freightAmount: 0,
        freightType: 0,
        freightCurrency: ''
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  async beforeMount() {

  },
  async created() {
    this.init()
  },
  mounted() {},
  methods: {
    init() {

    },
    closeHandler() {
      this.$emit('close')
    },
    saveHandler() {
      this.loading = getLoading4Cxt()
      const params = {}
      if (![0, 1].includes(this.type) || !this.uuids || this.uuids.length === 0) {
        return
      }
      params.keys = this.uuids
      if (this.type === 0) {
        params.routeMarking = this.from.routeMarking
        params.type = 2 // 航线标记
      }
      if (this.type === 1) {
        params.type = 3 // 航班改配
        params.etd = this.from.etd
        params.voyageFlight = this.from.voyageFlight
        params.freightAmount = this.from.freightAmount
        params.freightType = this.from.freightType
        params.freightCurrency = this.from.freightCurrency
      }
      updateRouteBookingFunc(params).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_RefreshCompleteStatus'))
        this.$emit('refresh')
        this.closeHandler()
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>
